import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.17 Case 17</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_17"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 17. This is a positive case.
                Beginning at the level of the occipital and temporal lobes,
                intense activity is seen in the left occipital region,
                identified here. This activity, located within the gray matter,
                exceeds that of the activity in the adjacent white matter. This
                finding alone would cause this case to be positive; however,
                let’s continue to examine the rest of the study.
              </p>
              <p>
                On the right-hand side, similar intense activity is seen in the gray matter within the right occipital region. Again, this activity exceeds that of the activity in the adjacent white matter. This focal activity would also cause this case to be positive. In the remainder of the temporal and occipital regions, there is loss of gray-white contrast. White matter tracts are not delineated on the right or the left.
              </p>
              <p>
                As we enter into the frontal cortices, intense focal uptake can
                also be seen here bilaterally. Further up, there is loss of
                gray-white contrast throughout the left and right frontal
                cortices, and white matter tracts are not delineated. As we
                enter into the parietal lobes bilaterally, distinct white matter
                tracts cannot be seen on the left or the right. In the posterior
                parietal region, there is loss of gray-white contrast
                bilaterally. And, as we review the remainder of the parietal
                region, there continues to be loss of gray-white contrast.
              </p>
              <p>
                As there is loss of gray-white contrast in multiple regions, as
                well as focal intense uptake in the gray matter that exceeds the
                activity in the adjacent white matter, this case is positive. If
                you called this case negative, you may want to review the case
                once again in the MIMcloud Viewer
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-16"
          nextLesson="/module-4/module-4-1-18"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1056390968&entry_id=1_nbalbjny&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_nbalbjny"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
